export default __webpack_public_path__ + "static/media/Nav_Bar_Background.a3d44516.png";